<script lang="ts" module>
  import { useIsTextGeneratorEnabled } from '@/teoCore/hooks/use-dynamic-config-value.svelte';
  import { TeoCore } from '@/teoCore/TeoCore';
  import { useIsCurrentTextSet } from '@/teoCore/text/hooks/use-is-current-text-set';
  import type { TeoText } from '@/teoCore/text/TeoText';
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import ContentCard, { type ContentCardProps } from '@/ui/elements/card/ContentCard.svelte';

  import TaskMaster from './cmps/TaskMaster.svelte';

  export interface AdditionalProps {
    text: TeoText;
  }

  type InitCardProps = AdditionalProps & ContentCardProps;
</script>

<script lang="ts">
  let { text, ...props }: InitCardProps = $props();
  let isTextGeneratorEnabled = useIsTextGeneratorEnabled();
  let isCurrentTextSet = useIsCurrentTextSet();

  let gotConfig = $state(false);

  $effect(() => {
    gotConfig = text.configIsSet();
    text.events.addEventListener('configChanged', onChange);
    return () => {
      text.events.removeEventListener('configChanged', onChange);
    };
  });

  function switchToTextGenerator() {
    TeoCore.instance.activeText?.ui.update('view', 'text-generator');
  }

  function onChange() {
    gotConfig = text.configIsSet();
  }
</script>

<ContentCard {...props}>
  {#if isTextGeneratorEnabled.current}
    <TaskMaster taskLabel="Wähle eine Analyse-Konfiguration" done={gotConfig}></TaskMaster>
    <TaskMaster taskLabel="Füge deinen Text ein" done={isCurrentTextSet.current}></TaskMaster>
    {#if !isCurrentTextSet.current}
      <CtaButton variant="primary" icon="MagicButton" onclick={switchToTextGenerator}
        >Neuen Text generieren...</CtaButton
      >
    {/if}
  {:else}
    <TaskMaster taskLabel="Füge deinen Text ein" done={isCurrentTextSet.current}></TaskMaster>
    <TaskMaster taskLabel="Wähle eine Analyse-Konfiguration" done={gotConfig}></TaskMaster>
  {/if}
</ContentCard>
